import "../../../../content/departments/sites/research.css";
import * as React from 'react';
export default {
  React
};